export default defineNuxtPlugin(() => {
  // 子站暂时注释翻译接口调用，避免跨域 CORS 报错
  // const { updateTranslate } = useCustomTranslate()
  // updateTranslate()
})
